import React from "react";
import { Col } from "reactstrap";

///TODO TO BE CHANGES TO ICONS WHEN THE DESGIN IS READY
const renderStatIcon = (type) => {
  switch (type) {
    case "users":
      return (
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
          <path d="M16 3.13a4 4 0 0 1 0 7.75" />
        </svg>
      );
    case "calendar":
      return (
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
          <line x1="16" y1="2" x2="16" y2="6" />
          <line x1="8" y1="2" x2="8" y2="6" />
          <line x1="3" y1="10" x2="21" y2="10" />
          <path d="M8 14h.01M12 14h.01M16 14h.01M8 18h.01M12 18h.01M16 18h.01" />
        </svg>
      );
    case "bulb":
      return (
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M9 18h6" />
          <path d="M10 22h4" />
          <path d="M15.09 14c.18-.98.65-1.74 1.41-2.5A4.65 4.65 0 0 0 18 8 6 6 0 0 0 6 8c0 1.55.6 2.8 1.5 3.5.76.76 1.23 1.52 1.41 2.5" />
        </svg>
      );
    case "chart":
    default:
      return (
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <line x1="18" y1="20" x2="18" y2="10" />
          <line x1="12" y1="20" x2="12" y2="4" />
          <line x1="6" y1="20" x2="6" y2="14" />
        </svg>
      );
  }
};

const StudentStats = ({
  title,
  value,
  iconType,
  badgeBg = "#E6F7F5",
  iconColor = "#0D9488",
  ...colProps
}) => {
  return (
    <Col xs={6} md={6} lg={3} {...colProps}>
      <div className="student-stats-card-new">
        <div className="stats-card-header d-flex align-items-center justify-content-between">
          <span className="stats-card-title">{title}</span>
          <div
            className="stats-card-icon-badge"
            style={{ backgroundColor: badgeBg, color: iconColor }}
          >
            {renderStatIcon(iconType)}
          </div>
        </div>
        <div className="stats-card-value text-center mt-2">
          <h4>{value}</h4>
        </div>
      </div>
    </Col>
  );
};

export default StudentStats;
